// //////////////////////////////
// IMPORT MODULES
import React from 'react';
import PropTypes from 'prop-types';

// //////////////////////////////
// IMPORT HIGHER ORDER COMPONENTS OR FUNCTIONS

// //////////////////////////////
// IMPORT COMPONENTS
import Icon from './Icon';

// //////////////////////////////
// IMPORT IMAGES

// //////////////////////////////
// IMPORT STYLES
import styles from './Icons.module.scss';

// //////////////////////////////
// ICONS / IconLogoNoStripe

export function IconLogoNoStripe({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 194 99"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <g fillRule="nonzero">
        <path d="M0 42V0h9v42zM24.378 18.642v23.356H16V10.77h8.311v1.75a15.33 15.33 0 0 1 7.375-2.5 10.183 10.183 0 0 1 7.82 2.937 23.442 23.442 0 0 1 10.498-2.937c1.779-.052 3.55.245 5.213.875a7.614 7.614 0 0 1 3.378 2.72 12.373 12.373 0 0 1 1.843 4.685c.403 2.236.59 4.505.559 6.777V42H52.63V25.32a14.947 14.947 0 0 0-.875-5.902 3.46 3.46 0 0 0-3.498-1.906 18.29 18.29 0 0 0-4.874.875l-.931.313c.083 1.583.145 2.957.186 4.123.04 1.167.061 2.166.061 2.998V42h-8.378V25.95c0-1.541-.052-2.853-.156-3.936a8.108 8.108 0 0 0-.622-2.622 2.935 2.935 0 0 0-1.346-1.439 5.05 5.05 0 0 0-2.25-.437 14.208 14.208 0 0 0-4.812.875l-.758.251zM75.455 55H67V10.752h8.387v1.682a14.61 14.61 0 0 1 7.188-2.43 15.314 15.314 0 0 1 5.55.906 8.76 8.76 0 0 1 3.848 2.865 13.429 13.429 0 0 1 2.27 5.143 33.54 33.54 0 0 1 .751 7.664 29.903 29.903 0 0 1-.82 7.571 11.73 11.73 0 0 1-2.552 4.986 9.6 9.6 0 0 1-4.447 2.712c-2.114.58-4.302.852-6.495.81a29.303 29.303 0 0 1-4.48-.372l-.751-.124L75.455 55zm5.486-37.517a12.977 12.977 0 0 0-4.73.928l-.75.312V35.06a36.67 36.67 0 0 0 4.6.372 5.512 5.512 0 0 0 5.02-2.119 14.054 14.054 0 0 0 1.355-7.24c-.006-5.728-1.838-8.591-5.495-8.591zM122.946 20.583v13.093c.011.73.182 1.45.5 2.107.387.479.945.784 1.554.85l-.249 6.361a23.343 23.343 0 0 1-5.075-.443 11.298 11.298 0 0 1-3.83-1.765 20.788 20.788 0 0 1-9.155 2.206c-6.431 0-9.647-3.442-9.647-10.327a8.57 8.57 0 0 1 2.685-7.148 14.922 14.922 0 0 1 8.22-2.488l6.662-.503v-1.95a3.352 3.352 0 0 0-.872-2.678 4.367 4.367 0 0 0-2.801-.724l-11.708.503-.249-5.848A48.52 48.52 0 0 1 111.687 10c4.028 0 6.914.84 8.656 2.52a10.758 10.758 0 0 1 2.603 8.063zm-8.348 7.808l-5.666.503a3.361 3.361 0 0 0-2.597 1.083 3.442 3.442 0 0 0-.89 2.695c0 2.308 1.017 3.462 3.051 3.463a19.968 19.968 0 0 0 5.163-.75l.928-.253.011-6.741zM141.07 10c2.774.064 5.535.402 8.244 1.01l1.673.375-.25 6.684c-1.653-.179-3.078-.308-4.276-.386a51.923 51.923 0 0 0-2.976-.126 12.72 12.72 0 0 0-3.496.418 4.024 4.024 0 0 0-2.168 1.45 6.453 6.453 0 0 0-1.084 2.74 24.451 24.451 0 0 0-.31 4.28 24.97 24.97 0 0 0 .303 4.316 6.493 6.493 0 0 0 1.084 2.769 4.188 4.188 0 0 0 2.168 1.48c1.161.324 2.363.473 3.566.44l7.203-.504.249 6.74A55.495 55.495 0 0 1 140.894 43c-4.586 0-7.881-1.313-9.886-3.94-2.004-2.626-3.007-6.835-3.008-12.626 0-5.794 1.034-9.984 3.1-12.57 2.068-2.584 5.391-3.873 9.97-3.864zM173.938 11.542v7.004h-7.76v12.597c0 .612 0 1.137.031 1.566.012.341.044.682.096 1.02.072.512.316.987.694 1.35.51.412 1.168.61 1.829.55l4.796-.125.376 6.576a32.892 32.892 0 0 1-6.435.915 16.273 16.273 0 0 1-4.731-.585 6.24 6.24 0 0 1-3.028-1.937 8.053 8.053 0 0 1-1.609-3.594 27.976 27.976 0 0 1-.481-5.565V18.546H154v-7.004h3.714V3h8.458v8.542h7.766zM24.388 97V79.587H8.597V97H0V55.004h8.607v17.171h15.79V55H33v41.996zM53.477 66.007c5.205 0 8.92 1.438 11.146 4.315a19.398 19.398 0 0 1 3.341 12.115c0 11.044-4.827 16.566-14.48 16.563-9.655-.003-14.482-5.524-14.482-16.563-.028-2.29.224-4.573.75-6.801a13.418 13.418 0 0 1 2.456-5.164 11.056 11.056 0 0 1 4.464-3.306 17.659 17.659 0 0 1 6.805-1.16zm0 25.82a4.877 4.877 0 0 0 4.66-2.234 15.242 15.242 0 0 0 1.253-7.149 14.906 14.906 0 0 0-1.253-7.084 6.083 6.083 0 0 0-9.319 0 14.804 14.804 0 0 0-1.253 7.084c0 1.094.052 2.196.156 3.306a9.659 9.659 0 0 0 .75 3.023c.377.879.983 1.64 1.756 2.204.965.622 2.104.92 3.25.85zM81.236 98H73V66.747h8.17v3.316A32.58 32.58 0 0 1 91 66v8.438a73.91 73.91 0 0 0-4.64 1.063 99.594 99.594 0 0 0-3.9 1.117l-1.222.44L81.236 98zM94 62.548V54h8v8.548h-8zM94 98V66.57h8v31.428L94 98zM108 73.44V66h23v7.44l-13.02 16.12H131V97h-23v-7.44l13.022-16.12zM148.478 66.007c5.205 0 8.92 1.438 11.146 4.315a19.398 19.398 0 0 1 3.34 12.115c0 11.044-4.827 16.566-14.48 16.563-9.653-.003-14.48-5.524-14.482-16.563a28.11 28.11 0 0 1 .75-6.801 13.422 13.422 0 0 1 2.456-5.164 11.067 11.067 0 0 1 4.464-3.306 17.657 17.657 0 0 1 6.806-1.159zm0 25.82a4.876 4.876 0 0 0 4.652-2.236c.99-2.246 1.42-4.7 1.253-7.148a14.903 14.903 0 0 0-1.253-7.085 6.082 6.082 0 0 0-9.318 0 14.773 14.773 0 0 0-1.253 7.085c0 1.093.052 2.195.156 3.305a9.663 9.663 0 0 0 .75 3.023c.377.879.983 1.64 1.755 2.204a5.395 5.395 0 0 0 3.258.852zM175.34 74.627v23.366H167V66.756h8.273v1.75a15.283 15.283 0 0 1 7.784-2.5 13.064 13.064 0 0 1 5.189.906 7.706 7.706 0 0 1 3.36 2.781 12.56 12.56 0 0 1 1.834 4.685c.403 2.205.589 4.444.556 6.685V98h-8.34V81.32c.118-2.012-.198-4.026-.926-5.904A3.74 3.74 0 0 0 181 73.51c-1.677.004-3.34.3-4.915.875l-.745.242z" />
      </g>
    </Icon>
  );
}

IconLogoNoStripe.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconLogoNoStripe.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconLogo

export function IconLogo({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 222 99"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="#463A93" />
          <stop offset="100%" stopColor="#F13B48" />
        </linearGradient>
      </defs>
      <g fillRule="nonzero">
        <path d="M28 42V0h9v42zM52.378 18.642v23.356H44V10.77h8.311v1.75a15.33 15.33 0 0 1 7.375-2.5 10.183 10.183 0 0 1 7.82 2.937 23.442 23.442 0 0 1 10.498-2.937c1.779-.052 3.55.245 5.213.875a7.614 7.614 0 0 1 3.378 2.72 12.373 12.373 0 0 1 1.843 4.685c.403 2.236.59 4.505.559 6.777V42H80.63V25.32a14.947 14.947 0 0 0-.875-5.902 3.46 3.46 0 0 0-3.498-1.906 18.29 18.29 0 0 0-4.874.875l-.931.313c.083 1.583.145 2.957.186 4.123.04 1.167.061 2.166.061 2.998V42h-8.378V25.95c0-1.541-.052-2.853-.156-3.936a8.108 8.108 0 0 0-.622-2.622 2.935 2.935 0 0 0-1.346-1.439 5.05 5.05 0 0 0-2.25-.437 14.208 14.208 0 0 0-4.812.875l-.758.251zM103.455 55H95V10.752h8.387v1.682a14.61 14.61 0 0 1 7.188-2.43 15.314 15.314 0 0 1 5.55.906 8.76 8.76 0 0 1 3.848 2.865 13.429 13.429 0 0 1 2.27 5.143 33.54 33.54 0 0 1 .751 7.664 29.903 29.903 0 0 1-.82 7.571 11.73 11.73 0 0 1-2.552 4.986 9.6 9.6 0 0 1-4.447 2.712c-2.114.58-4.302.852-6.495.81a29.303 29.303 0 0 1-4.48-.372l-.751-.124.006 12.835zm5.486-37.517a12.977 12.977 0 0 0-4.73.928l-.75.312V35.06a36.67 36.67 0 0 0 4.6.372 5.512 5.512 0 0 0 5.02-2.119 14.054 14.054 0 0 0 1.355-7.24c-.006-5.728-1.838-8.591-5.495-8.591zM150.946 20.583v13.093c.011.73.182 1.45.5 2.107.387.479.945.784 1.554.85l-.249 6.361a23.343 23.343 0 0 1-5.075-.443 11.298 11.298 0 0 1-3.83-1.765 20.788 20.788 0 0 1-9.155 2.206c-6.431 0-9.647-3.442-9.647-10.327a8.57 8.57 0 0 1 2.685-7.148 14.922 14.922 0 0 1 8.22-2.488l6.662-.503v-1.95a3.352 3.352 0 0 0-.872-2.678 4.367 4.367 0 0 0-2.801-.724l-11.708.503-.249-5.848A48.52 48.52 0 0 1 139.687 10c4.028 0 6.914.84 8.656 2.52a10.758 10.758 0 0 1 2.603 8.063zm-8.348 7.808l-5.666.503a3.361 3.361 0 0 0-2.597 1.083 3.442 3.442 0 0 0-.89 2.695c0 2.308 1.017 3.462 3.051 3.463a19.968 19.968 0 0 0 5.163-.75l.928-.253.011-6.741zM169.07 10c2.774.064 5.535.402 8.244 1.01l1.673.375-.25 6.684c-1.653-.179-3.078-.308-4.276-.386a51.923 51.923 0 0 0-2.976-.126 12.72 12.72 0 0 0-3.496.418 4.024 4.024 0 0 0-2.168 1.45 6.453 6.453 0 0 0-1.084 2.74 24.451 24.451 0 0 0-.31 4.28 24.97 24.97 0 0 0 .303 4.316 6.493 6.493 0 0 0 1.084 2.769 4.188 4.188 0 0 0 2.168 1.48c1.161.324 2.363.473 3.566.44l7.203-.504.249 6.74A55.495 55.495 0 0 1 168.894 43c-4.586 0-7.881-1.313-9.886-3.94-2.004-2.626-3.007-6.835-3.008-12.626 0-5.794 1.034-9.984 3.1-12.57 2.068-2.584 5.391-3.873 9.97-3.864zM201.938 11.542v7.004h-7.76v12.597c0 .612 0 1.137.031 1.566.012.341.044.682.096 1.02.072.512.316.987.694 1.35.51.412 1.168.61 1.829.55l4.796-.125.376 6.576a32.892 32.892 0 0 1-6.435.915 16.273 16.273 0 0 1-4.731-.585 6.24 6.24 0 0 1-3.028-1.937 8.053 8.053 0 0 1-1.609-3.594 27.976 27.976 0 0 1-.481-5.565V18.546H182v-7.004h3.714V3h8.458v8.542h7.766zM52.388 97V79.587H36.597V97H28V55.004h8.607v17.171h15.79V55H61v41.996zM81.477 66.007c5.205 0 8.92 1.438 11.146 4.315a19.398 19.398 0 0 1 3.341 12.115c0 11.044-4.827 16.566-14.48 16.563-9.655-.003-14.482-5.524-14.482-16.563-.028-2.29.224-4.573.75-6.801a13.418 13.418 0 0 1 2.456-5.164 11.056 11.056 0 0 1 4.464-3.306 17.659 17.659 0 0 1 6.805-1.16zm0 25.82a4.877 4.877 0 0 0 4.66-2.234 15.242 15.242 0 0 0 1.253-7.149 14.906 14.906 0 0 0-1.253-7.084 6.083 6.083 0 0 0-9.319 0 14.804 14.804 0 0 0-1.253 7.084c0 1.094.052 2.196.156 3.306a9.659 9.659 0 0 0 .75 3.023c.377.879.983 1.64 1.756 2.204.965.622 2.104.92 3.25.85zM109.236 98H101V66.747h8.17v3.316A32.58 32.58 0 0 1 119 66v8.438a73.91 73.91 0 0 0-4.64 1.063 99.594 99.594 0 0 0-3.9 1.117l-1.222.44L109.236 98zM122 62.548V54h8v8.548h-8zM122 98V66.57h8v31.428L122 98zM136 73.44V66h23v7.44l-13.02 16.12H159V97h-23v-7.44l13.022-16.12zM176.478 66.007c5.205 0 8.92 1.438 11.146 4.315a19.398 19.398 0 0 1 3.34 12.115c0 11.044-4.827 16.566-14.48 16.563-9.653-.003-14.48-5.524-14.482-16.563a28.11 28.11 0 0 1 .75-6.801 13.422 13.422 0 0 1 2.456-5.164 11.067 11.067 0 0 1 4.464-3.306 17.657 17.657 0 0 1 6.806-1.159zm0 25.82a4.876 4.876 0 0 0 4.652-2.236c.99-2.246 1.42-4.7 1.253-7.148a14.903 14.903 0 0 0-1.253-7.085 6.082 6.082 0 0 0-9.318 0 14.773 14.773 0 0 0-1.253 7.085c0 1.093.052 2.195.156 3.305a9.663 9.663 0 0 0 .75 3.023c.377.879.983 1.64 1.755 2.204a5.395 5.395 0 0 0 3.258.852zM203.34 74.627v23.366H195V66.756h8.273v1.75a15.283 15.283 0 0 1 7.784-2.5 13.064 13.064 0 0 1 5.189.906 7.706 7.706 0 0 1 3.36 2.781 12.56 12.56 0 0 1 1.834 4.685c.403 2.205.589 4.444.556 6.685V98h-8.34V81.32c.118-2.012-.198-4.026-.926-5.904A3.74 3.74 0 0 0 209 73.51c-1.677.004-3.34.3-4.915.875l-.745.242z" />
        <path fill="url(#a)" d="M0 0h9v98H0z" />
      </g>
    </Icon>
  );
}

IconLogo.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconLogo.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconAnalytics

export function IconAnalytics({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 115 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M72.34 34.28a23.261 23.261 0 0 1 4.177 12.299L62.009 61.035a5.864 5.864 0 0 1-8.249 0l-9.98-9.933-9.99 9.933a23.265 23.265 0 0 1-4.213-12.288l10.05-10.014a5.864 5.864 0 0 1 8.25 0l10.015 9.944L72.34 34.28zm2.866 35.43c-12.221 12.163-32.022 12.155-44.233-.019-12.212-12.173-12.212-31.905 0-44.078 12.21-12.173 32.012-12.182 44.233-.019a31.119 31.119 0 0 1 9.177 22.058c0 8.275-3.301 16.21-9.177 22.057v.001zM111.546.015L89.502 2.008a2.771 2.771 0 0 0-2.314 1.8 2.756 2.756 0 0 0 .606 2.863l4.47 4.455 1.66 1.643-7.92 7.893c-1.299-1.574-2.773-3.054-2.773-3.054-16.65-16.552-43.603-16.552-60.252 0C10.639 29.89 7.044 48.423 13.9 64.405L2.04 76.226a5.817 5.817 0 0 0-1.876 5.789 5.84 5.84 0 0 0 4.316 4.3 5.862 5.862 0 0 0 5.809-1.868l9.862-9.829c1.31 1.586 2.785 3.055 2.785 3.055 15.1 15.018 39.014 16.606 55.98 3.718L96.09 98.494a5.677 5.677 0 0 0 7.855-.147 5.628 5.628 0 0 0 .148-7.827L86.906 73.393a42.454 42.454 0 0 0 5.288-42.506l9.921-9.875 1.638 1.632 4.47 4.454a2.78 2.78 0 0 0 2.872.604 2.765 2.765 0 0 0 1.807-2.306l2.083-21.953a3.13 3.13 0 0 0-.907-2.524 3.154 3.154 0 0 0-2.533-.904z"
      />
    </Icon>
  );
}

IconAnalytics.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconAnalytics.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconBack

export function IconBack({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 132 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M58.031 10.204v21.64l5.224.052c36.29.35 56.733 16.49 62.058 49.194C105.377 58.033 82.39 58.023 63.31 58.018H58.03v21.455L9.127 44.836 58.03 10.204zM63.307 0L0 44.836l63.307 44.836v-26.38C88.644 63.304 112.134 64.58 132 100c0-22.495-3.717-72.75-68.693-73.379V0z"
      />
    </Icon>
  );
}

IconBack.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconBack.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconContactPin

export function IconContactPin({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 71 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M71 35.294C71 15.824 55.084 0 35.5 0S0 15.824 0 35.294C0 61.764 35.5 100 35.5 100S71 61.765 71 35.294zm-47.333 0c0-6.47 5.325-11.765 11.833-11.765s11.833 5.295 11.833 11.765c0 6.47-5.265 11.765-11.833 11.765-6.508 0-11.833-5.294-11.833-11.765z"
      />
    </Icon>
  );
}

IconContactPin.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconContactPin.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconDigitalSystems

export function IconDigitalSystems({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 105 99"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <g fillRule="evenodd">
        <path
          fillRule="nonzero"
          d="M35 58.571H14.286L0 72.857V58.72c0-.15.104-.297.304-.44H0V.423h71.429V28.57h-5V6.137H5V56.7l2.227-2.227 2.265-2.265H35v6.363z"
        />
        <path d="M5 19.708h14.286v2.143H5z" />
        <path d="M17.143 19.708h2.143v12.143h-2.143z" />
        <path d="M17.857 41.851a5.714 5.714 0 1 1 0-11.428 5.714 5.714 0 0 1 0 11.428zm0-2.143a3.571 3.571 0 1 0 0-7.143 3.571 3.571 0 0 0 0 7.143zM44.286 14.286h22.143v2.143H44.286z" />
        <g>
          <path
            fillRule="nonzero"
            d="M104.286 84.726v14.137L90 84.577H40c-2.619 0-5-.558-7.143-1.675 0-3.928 71.429-2.105 71.429 1.824z"
          />
          <path d="M104.286 26.429H32.857v57.857h71.429V26.429zM37.857 78.214V32.143h61.429v50.563l-2.227-2.227-2.265-2.265H37.857z" />
          <path d="M37.857 45.714h14.286v2.143H37.857z" />
          <path d="M50 45.714h2.143v12.143H50z" />
          <path d="M50.714 67.857a5.714 5.714 0 1 1 0-11.428 5.714 5.714 0 0 1 0 11.428zm0-2.143a3.571 3.571 0 1 0 0-7.143 3.571 3.571 0 0 0 0 7.143zM67.571 31.429v14.286h2.143V31.429z" />
          <path d="M67.571 43.572v2.143h12.143v-2.143z" />
          <path d="M89.714 44.286a5.714 5.714 0 1 0-11.428 0 5.714 5.714 0 0 0 11.428 0zm-2.143 0a3.571 3.571 0 1 1-7.142 0 3.571 3.571 0 0 1 7.142 0zM82.857 60.715h17.857v2.143H82.857z" />
          <path d="M84.286 62.143a5.714 5.714 0 1 0-11.429 0 5.714 5.714 0 0 0 11.429 0zm-2.143 0a3.571 3.571 0 1 1-7.143 0 3.571 3.571 0 0 1 7.143 0z" />
        </g>
        <path d="M44.286 15.423a5.714 5.714 0 1 0-11.429 0 5.714 5.714 0 0 0 11.429 0zm-2.143 0a3.571 3.571 0 1 1-7.143 0 3.571 3.571 0 0 1 7.143 0z" />
      </g>
    </Icon>
  );
}

IconDigitalSystems.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconDigitalSystems.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconNoGuesswork

export function IconNoGuesswork({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 61 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <g fillRule="nonzero">
        <path d="M1.89 63.265L0 0h21l-2.011 63.265H1.89zM0 100V76.265h20.86V100H0z" />
        <path
          d="M47.119 10c9.266 0 13.892 3.823 13.879 11.468a47.754 47.754 0 0 1-.2 4.865 12.358 12.358 0 0 1-.88 3.495 8.659 8.659 0 0 1-1.8 2.719 25.57 25.57 0 0 1-2.94 2.616 21.18 21.18 0 0 0-4.54 4.272 5.668 5.668 0 0 0-.94 3.169v2.289H42a9.763 9.763 0 0 1-2.24-6.705c0-1.757 1.54-3.904 4.62-6.397A39.521 39.521 0 0 0 50 26.558a6.043 6.043 0 0 0 1-3.455c0-2.882-2-4.333-6.12-4.333-2.974.005-5.94.3-8.86.879l-1.499.286-.52-7.42a34.213 34.213 0 0 1 13.119-2.514zm3.66 51h-10.36V49.145h10.36V61z"
          opacity=".5"
        />
      </g>
    </Icon>
  );
}

IconNoGuesswork.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconNoGuesswork.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconStakeholder

export function IconStakeholder({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 194 99"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
        <g fillRule="evenodd">
          <path d="M87.445 20.278c4.315 0 7.813-3.492 7.813-7.8s-3.498-7.8-7.813-7.8c-4.314 0-7.812 3.492-7.812 7.8s3.498 7.8 7.812 7.8zM50 15.6c-4.315 0-7.812-3.492-7.812-7.8S45.685 0 50 0s7.813 3.492 7.813 7.8-3.498 7.8-7.813 7.8zm-37.445 4.678c-4.315 0-7.812-3.492-7.812-7.8s3.497-7.8 7.812-7.8 7.813 3.492 7.813 7.8a7.793 7.793 0 0 1-2.289 5.515 7.819 7.819 0 0 1-5.524 2.285zm7.159 12.56C15.975 18.654 0 23.868 0 32.242V70.42c0 1.822 1.246 3.287 3.12 3.287H6L2.139 85.86a2.338 2.338 0 0 0 .284 2.142 2.346 2.346 0 0 0 1.92.998H28.9l.993-4.68H7.543l14.14-44.525h56.634l14.14 44.525h-22.35L71.1 89h24.557c.747 0 1.449-.356 1.89-.957a2.337 2.337 0 0 0 .344-2.088l-3.89-12.247h2.879c1.875 0 3.12-1.464 3.12-3.286v-38.18c0-8.373-15.975-13.588-19.714.596l-.6 2.276H64.103l-1.026-7.522c-.582-4.277-7.235-7.344-13.077-7.344-5.841 0-12.493 3.065-13.077 7.345l-1.026 7.521H20.313l-.6-2.276z" />
          <path d="M50.5 70.023c-5.868 0-10.625-4.706-10.625-10.512C39.875 53.706 44.632 49 50.5 49s10.625 4.706 10.625 10.511c0 5.806-4.757 10.512-10.625 10.512zM35.379 82.409c.817-4.253 8.367-7.332 15.121-7.332s14.304 3.079 15.121 7.332L69 100H32l3.379-17.591z" />
        </g>
      </svg>
    </Icon>
  );
}

IconStakeholder.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconStakeholder.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconArrowRight

export function IconArrowRight({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 50 81"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M0 71.483L30.904 40.5 0 9.517 9.514 0 50 40.5 9.514 81z"
      />
    </Icon>
  );
}

IconArrowRight.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconArrowRight.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconArrowDown

export function IconArrowDown({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 81 50"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M9.517 0L40.5 30.904 71.482 0 81 9.514 40.5 50 0 9.514z"
      />
    </Icon>
  );
}

IconArrowDown.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconArrowDown.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconArrowLeft

export function IconArrowLeft({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 50 81"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M50 9.517L40.486 0 0 40.5 40.486 81 50 71.483 19.096 40.5z"
      />
    </Icon>
  );
}

IconArrowLeft.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconArrowLeft.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconArrowUp

export function IconArrowUp({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 81 50"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M9.517 50L40.5 19.096 71.482 50 81 40.486 40.5 0 0 40.486z"
      />
    </Icon>
  );
}

IconArrowUp.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconArrowUp.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconHome

export function IconHome({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 118 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M58.824 15.824l29.411 26.47v45.941H76.471V52.941H41.176v35.294H29.412v-45.94l29.412-26.471zm0-15.824L0 52.941h17.647V100h35.294V64.706h11.765V100H100V52.941h17.647L58.824 0z"
      />
    </Icon>
  );
}

IconHome.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconHome.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconBarChart

export function IconBarChart({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M100 30H78.571v70H100V30zM60 0H40v100h20V0zM20 57.143H0V100h20V57.143z"
      />
    </Icon>
  );
}

IconBarChart.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconBarChart.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconPaperclip

export function IconPaperclip({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M91.034 8.966C85.517 3.448 77.931.69 69.654 0a30.256 30.256 0 0 0-21.378 8.966 7.45 7.45 0 0 0-2.07 4.827 6.26 6.26 0 0 0 2.07 4.828 7.45 7.45 0 0 0 4.827 2.069 6.261 6.261 0 0 0 4.828-2.07c6.896-6.206 17.241-6.206 23.448 0 2.758 3.45 4.138 6.897 4.138 11.035a17.994 17.994 0 0 1-4.827 11.724L41.38 80.69c-6.898 6.207-17.242 6.207-23.45 0-2.758-2.758-4.827-6.896-4.827-11.035a17.994 17.994 0 0 1 4.828-11.724L34.482 41.38a4.607 4.607 0 0 1 6.897 0 5.412 5.412 0 0 1 0 7.583L28.963 61.38a7.45 7.45 0 0 0-2.07 4.827 6.261 6.261 0 0 0 2.07 4.828 8.285 8.285 0 0 0 9.655 0l12.416-12.417c7.584-7.583 7.584-19.31 0-26.206a18.842 18.842 0 0 0-13.103-5.518c-4.828 0-9.655 1.38-12.416 4.828L8.963 48.272C2.758 53.793 0 61.38 0 69.655a30.257 30.257 0 0 0 8.966 21.38c5.517 5.517 13.103 8.275 21.379 8.965a30.257 30.257 0 0 0 21.38-8.966l39.31-39.31a29.974 29.974 0 0 0 0-42.758z"
      />
    </Icon>
  );
}

IconPaperclip.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconPaperclip.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconChartUpTrend

export function IconChartUpTrend({
  className,
  title,
  ariaLabelledby,
  ariaHidden,
}) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 154 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M11.55 100l46.2-46.302 30.8 30.817L154 10.863 143.143 0 88.55 61.402l-30.8-30.816L0 88.444z"
      />
    </Icon>
  );
}

IconChartUpTrend.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconChartUpTrend.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconContact

export function IconContact({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 125 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M112.5 0h-100C5.625 0 .062 5.625.062 12.5L0 87.5C0 94.375 5.625 100 12.5 100h100c6.875 0 12.5-5.625 12.5-12.5v-75C125 5.625 119.375 0 112.5 0zm0 87.5h-100V25l50 31.25 50-31.25v62.5zm-50-43.75l-50-31.25h100l-50 31.25z"
      />
    </Icon>
  );
}

IconContact.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconContact.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconDownload

export function IconDownload({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 75 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M19.956 47.988l14.17 14.093V1.695C34.125.758 34.886 0 35.83 0s1.705.758 1.705 1.695v60.244l14.1-14.02a1.71 1.71 0 0 1 2.41 0 1.686 1.686 0 0 1 0 2.396L37.185 67.08c-.31.423-.787.717-1.355.717-.014 0-.024-.007-.036-.007-.012 0-.024.007-.036.007a1.69 1.69 0 0 1-1.203-.499l-17.01-16.913a1.686 1.686 0 0 1 0-2.397 1.71 1.71 0 0 1 2.41 0zm29.476-20.87H75V100H0V27.119h25.568c.943 0 1.705.757 1.705 1.695 0 .937-.762 1.694-1.705 1.694H3.41V96.61h68.182V30.508H49.43a1.698 1.698 0 0 1-1.704-1.694c0-.938.762-1.695 1.705-1.695z"
      />
    </Icon>
  );
}

IconDownload.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconDownload.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconMinus

export function IconMinus({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 20"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path fillRule="nonzero" d="M0 0v20h100V0z" />
    </Icon>
  );
}

IconMinus.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconMinus.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconPlus

export function IconPlus({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path fillRule="nonzero" d="M60 0H40v40H0v20h40v40h20V60h40V40H60z" />
    </Icon>
  );
}

IconPlus.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconPlus.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconBurger

export function IconBurger({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 67"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M0 67h100V55.833H0V67zm0-27.917h100V27.917H0v11.166zM0 0v11.167h100V0H0z"
      />
    </Icon>
  );
}

IconBurger.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconBurger.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};

// //////////////////////////////
// ICONS / IconX

export function IconX({ className, title, ariaLabelledby, ariaHidden }) {
  return (
    <Icon
      title={title}
      className={className}
      viewBoxDimensions="0 0 100 100"
      ariaLabelledby={ariaLabelledby} // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-labelledby_attribute
      ariaHidden={ariaHidden} // https://developer.paciellogroup.com/blog/2012/05/html5-accessibility-chops-hidden-and-aria-hidden/
    >
      <path
        fillRule="nonzero"
        d="M100 10.071L89.929 0 50 39.929 10.071 0 0 10.071 39.929 50 0 89.929 10.071 100 50 60.071 89.929 100 100 89.929 60.071 50z"
      />
    </Icon>
  );
}

IconX.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  ariaLabelledby: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

IconX.defaultProps = {
  className: `${styles['icons']}`,
  ariaLabelledby: null,
  ariaHidden: false,
};
